module.exports = __webpack_public_path__ + "img/ldz_v5jh.3e5176ba.png";